import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { combineLatest, takeUntil } from 'rxjs';

import { IPaymentMode, SdPaymentModeComponent } from '@seb/web-design-system/payment';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';

import { AbstractComponent } from '../abstract-component.component';
import { ServiceOptionsComponentInterface } from '../../../models';
import { ComponentService, ImageService } from '../../../services';

@Component({
  selector: 'wc-service-options',
  templateUrl: './service-options.component.html',
  styleUrls: ['./service-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdPaymentModeComponent]
})
export class ServiceOptionsComponent extends AbstractComponent<ServiceOptionsComponentInterface> implements OnInit {
  paymentMode: IPaymentMode;

  constructor(
    private componentService: ComponentService,
    private imageService: ImageService,
    private activeCartService: ActiveCartService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    combineLatest([
      this.activeCartService.getActive(),
      this.component$.pipe(this.componentService.reloadComponentForArrayProperties(['medias']))
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([cart, serviceOptionsComponents]: [Cart, ServiceOptionsComponentInterface]) => {
        if (serviceOptionsComponents.orderType === cart.orderType) {
          this.paymentMode = this.toPaymentModeObjects(serviceOptionsComponents);
        }
        this.setLoaded();
        this.cdRef.markForCheck();
      });
  }

  private toPaymentModeObjects(cmp: ServiceOptionsComponentInterface): IPaymentMode {
    return {
      mode: cmp.headline,
      medias: cmp.medias
        ? Object.keys(cmp.medias)
          .map((key) => cmp.medias[key])
          .map((media) => this.imageService.normalizeMedia(media))
        : null
    };
  }
}
